<template xmlns:v-bind="http://www.w3.org/1999/xhtml"
          xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div class="pilot-details" :class="{ active: isActive }">
    <div>
      <span class="id">
        <span>#</span>
        <span>{{ squadronSlot.position }}</span>
      </span>
      <div class="status">
        <template v-if="squadronSlot.pilot != null">
          <icon-bailed-out
            v-if="squadronSlot.pilot.status == PilotStatus.isBailingOut
            || squadronSlot.pilot.status == PilotStatus.bailedOut"></icon-bailed-out>
          <icon-captured v-if="squadronSlot.pilot.status == PilotStatus.captured"></icon-captured>
          <icon-injured v-if="squadronSlot.pilot.status == PilotStatus.injured"></icon-injured>
          <icon-killed v-if="squadronSlot.pilot.status == PilotStatus.killed"></icon-killed>
          <icon-lost v-if="squadronSlot.pilot.status == PilotStatus.lost"></icon-lost>
        </template>
      </div>
    </div>
    <div class="rank-quality">
      <template v-if="squadronSlot.pilot != null">
        <span class="rank">{{ squadronSlot.pilot.name }}</span>
        <span class="rank">{{ squadronSlot.pilot.rank }}</span>
        <span>
        <span class="quality">{{ squadronSlot.pilot.quality }}
        </span>
        <span class="kills"
              v-if="squadronSlot.pilot.kills > 0">
          – {{ squadronSlot.pilot.kills }}
          <span v-if="squadronSlot.pilot.kills === 1">kill</span>
          <span v-else="">kills</span></span>
        </span>
      </template>
      <template v-else="">–</template>
      <div class="stats">
        <div v-if="hasKills">{{ kills.count }} killed</div>
        <div v-if="didDestroyAircrafts">
          {{ destroyedAircrafts.count }} destroyed
        </div>
        <div v-if="didDamageAircrafts">
          {{ damagedAircrafts.count }} damaged
        </div>
      </div>
    </div>
    <div class="actions" v-if="isActive && squadronSlot.pilot != null">
      <button @click="isMenuVisible = !isMenuVisible">...</button>
    </div>
    <div class="fullscreen"
         v-if="isMenuVisible"
         @click="isMenuVisible = !isMenuVisible"></div>
    <div class="context-menu"
         v-if="isMenuVisible">
      <ul>
        <li @click="addKill">+1 Kill (not shared)</li>
        <li @click="removeKill" v-if="hasKills">-1 Kill</li>
        <li @click="addAircraftDestroyed">+1 Aircraft destroyed</li>
        <li @click="removeAircraftDestroyed" v-if="didDestroyAircrafts">-1 Aircraft destroyed</li>
        <li @click="addAircraftDamaged">+1 Aircraft damaged</li>
        <li @click="removeAircraftDamaged" v-if="didDamageAircrafts">-1 Aircraft damaged</li>
        <li :class="{ disabled: squadronSlot.pilot.status === PilotStatus.active}"
            @click="changePilotStatus(PilotStatus.active)">Active
        </li>
        <li :class="{ disabled: squadronSlot.pilot.status === PilotStatus.isBailingOut}"
            @click="changePilotStatus(PilotStatus.isBailingOut)">Bailed out
        </li>
        <li :class="{ disabled: squadronSlot.pilot.status === PilotStatus.captured}"
            @click="changePilotStatus(PilotStatus.captured)">Captured
        </li>
        <li :class="{ disabled: squadronSlot.pilot.status === PilotStatus.injured}"
            @click="changePilotStatus(PilotStatus.injured)">Injured
        </li>
        <li :class="{ disabled: squadronSlot.pilot.status === PilotStatus.killed}"
            @click="changePilotStatus(PilotStatus.killed)">Killed
        </li>
        <li :class="{ disabled: squadronSlot.pilot.status === PilotStatus.lost}"
            @click="changePilotStatus(PilotStatus.lost)">Lost
        </li>
      </ul>
    </div>
  </div>
</template>

<script type="text/babel">
  import PilotStatus from '@/models/PilotStatus';
  import PilotQuality from '@/models/PilotQuality';
  import IconBailedOut from '@/assets/icons/BailedOut.vue';
  import IconKilled from '@/assets/icons/Killed.vue';
  import IconInjured from '@/assets/icons/Injured.vue';
  import IconLost from '@/assets/icons/Lost.vue';
  import IconCaptured from '@/assets/icons/Captured.vue';
  import moment from 'moment';
  import Dice from '@/models/Dice';
  import SortieLocations from '@/models/finestHour/SortieLocations';

  export default {
    props: {
      finestHour: {
        type: Object,
      },
      squadronSlot: {
        type: Object,
      },
      isActive: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      IconBailedOut,
      IconKilled,
      IconInjured,
      IconCaptured,
      IconLost,
    },
    data() {
      return {
        isMenuVisible: false,
        PilotStatus,
      };
    },
    computed: {
      hasKills() {
        return this.kills != null
          && this.kills.count > 0;
      },
      kills() {
        return this.finestHour.lastSortie.killsByPilot
          .find((x) => this.squadronSlot.pilot != null && x.id === this.squadronSlot.pilot.id);
      },
      didDestroyAircrafts() {
        return this.destroyedAircrafts != null
          && this.destroyedAircrafts.count > 0;
      },
      destroyedAircrafts() {
        return this.finestHour.lastSortie.aircraftsDestroyedByPilot
          .find((x) => this.squadronSlot.pilot != null && x.id === this.squadronSlot.pilot.id);
      },
      didDamageAircrafts() {
        return this.damagedAircrafts != null
          && this.damagedAircrafts.count > 0;
      },
      damagedAircrafts() {
        return this.finestHour.lastSortie.aircraftsDamagedByPilot
          .find((x) => this.squadronSlot.pilot != null && x.id === this.squadronSlot.pilot.id);
      },
    },
    methods: {
      addKill() {
        if (this.kills == null) {
          this.finestHour.lastSortie.killsByPilot.push({
            id: this.squadronSlot.pilot.id,
            count: 1,
          });
        } else {
          this.kills.count += 1;
        }
        this.isMenuVisible = false;
      },
      removeKill() {
        this.kills.count -= 1;
        this.isMenuVisible = false;
      },
      addAircraftDestroyed() {
        if (this.destroyedAircrafts == null) {
          this.finestHour.lastSortie.aircraftsDestroyedByPilot.push({
            id: this.squadronSlot.pilot.id,
            count: 1,
          });
        } else {
          this.destroyedAircrafts.count += 1;
        }
        this.isMenuVisible = false;
      },
      removeAircraftDestroyed() {
        this.destroyedAircrafts.count -= 1;
        this.isMenuVisible = false;
      },
      addAircraftDamaged() {
        if (this.damagedAircrafts == null) {
          this.finestHour.lastSortie.aircraftsDamagedByPilot.push({
            id: this.squadronSlot.pilot.id,
            count: 1,
          });
        } else {
          this.damagedAircrafts.count += 1;
        }
        this.isMenuVisible = false;
      },
      removeAircraftDamaged() {
        this.damagedAircrafts.count -= 1;
        this.isMenuVisible = false;
      },
      changePilotStatus(status) {
        this.squadronSlot.pilot.status = status;
        if (status === PilotStatus.injured) {
          let modifier = 0;
          switch (PilotQuality.indexOf(this.squadronSlot.pilot.quality)) {
            case 0:
              modifier = 2;
              break;
            case 1:
            case 2:
              modifier = 1;
              break;
            case 4:
              modifier = -1;
              break;
            default:
              break;
          }
          const roll = Dice.d6() + modifier;
          let daysOut = 0;
          switch (roll) {
            case 1:
            case 2:
            case 3:
              daysOut = Dice.d6() * 7;
              break;
            case 4:
              daysOut = Dice.d6(2);
              break;
            case 5:
              daysOut = Dice.d6();
              break;
            default:
              daysOut = 1;
              break;
          }
          this.squadronSlot.pilot.backOn = moment(this.finestHour.currentDate)
            .add(daysOut, 'days');
        } else if (status === PilotStatus.isBailingOut) {
          if (this.finestHour.lastSortie.location === SortieLocations.overFrance) {
            this.squadronSlot.pilot.status = PilotStatus.captured;
          } else if (this.finestHour.lastSortie.location === SortieLocations.overTheSea) {
            const bailOutRoll = Dice.d6()
              + (this.squadronSlot.pilot.quality === PilotQuality[0] ? 2 : 0)
              + (this.squadronSlot.pilot.quality === PilotQuality[1] ? 1 : 0)
              + (this.squadronSlot.pilot.quality === PilotQuality[4] ? -1 : 0)
              + (this.squadronSlot.pilot.status === PilotStatus.injured ? -2 : 0)
              + (this.finestHour.currentPhase !== 1 ? 1 : 0);
            if (bailOutRoll < 2) {
              this.squadronSlot.pilot.status = PilotStatus.killed;
            } else if (bailOutRoll < 4) {
              this.squadronSlot.pilot.status = PilotStatus.captured;
            } else {
              this.squadronSlot.pilot.status = PilotStatus.bailedOut;
              this.squadronSlot.pilot.backOn = moment(this.finestHour.currentDate)
                .add(1, 'days');
            }
          }
        }
        this.isMenuVisible = false;
      },
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import "../vars";

  .pilot-details {
    display: flex;
    padding: 1rem;
    position: relative;
    background: #eee;
    color: transparentize($text-color, 0.3);
    height: 4.2rem;

    &.active {
      color: $text-color;
      background: rgba(253, 238, 150, 0.38);
    }

    .id {
      width: 2.8rem;

      > span {
        margin-right: 0.3rem;
      }
    }

    .rank-quality {
      display: flex;
      flex-direction: column;
      flex-grow: 1;

      .rank {

      }

      .quality {
        font-weight: 600;
      }

      .kills {
        font-size: 0.9em;
      }

      .stats {
        display: flex;

        * {
          margin-left: 0.6rem;

          &:before {
            content: ', ';
          }

          &:first-of-type {
            margin-left: 0;

            &:before {
              content: '';
            }
          }
        }
      }
    }

    .status {
      margin-top: 0.3rem;
      width: 2.8rem;

      svg {
        width: 2rem;
      }
    }

    .fullscreen {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }

    .context-menu {
      position: absolute;
      background-color: #fff;
      border: solid 0.1rem $border-color;
      box-shadow: 0.1rem 0.1rem 0.5rem #00000077;
      right: 0;
      top: 2rem;
      z-index: 2;

      ul {
        margin: 0;
        padding: 0;
        list-style: none;
      }

      li {
        margin: 0;
        padding: 0.8rem 1.6rem;
        border-bottom: solid 0.1rem #eee;

        &:last-of-type {
          border-bottom: none;
        }

        &:hover {
          color: #fff;
          background-color: $text-color;
        }

        &.disabled {
          color: #ccc;
        }
      }
    }
  }
</style>
